import { c as _c } from "react/compiler-runtime";
import { Button } from '@systemeio/components';
import { ChevronRightIcon, Settings02Icon } from '@systemeio/icons';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { twMerge } from 'tailwind-merge';
import { useNotificationsActions } from '../hooks/use-notification-actions';
import { useNotifications } from '../hooks/use-notifications';
import NotificationEmptyList from './notification-empty-list';
import { NotificationItem } from './notification-item';
import NotificationsListSkeleton from './notifications-list-skeleton';
const defaultFilter = {
  onlyUnRead: false
};
interface NotificationsMenuContentProps {
  className?: string;
  limit?: number;
  /** Lets an overlay host close itself — a full-screen drawer hides the page the footer links open. */
  onNavigate?: () => void;
}
export const NotificationsMenuContent = t0 => {
  const $ = _c(51);
  const {
    className,
    limit: t1,
    onNavigate
  } = t0;
  const limit = t1 === undefined ? 3 : t1;
  const {
    t
  } = useLocoTranslation();
  const {
    pagination
  } = usePagination(true);
  let t2;
  if ($[0] !== limit || $[1] !== pagination) {
    t2 = {
      limit,
      pagination,
      filter: defaultFilter
    };
    $[0] = limit;
    $[1] = pagination;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    notifications
  } = useNotifications(t2);
  const {
    isMarkingAllAsRead,
    markAllNotificationsAsRead
  } = useNotificationsActions();
  let t3;
  if ($[3] !== className) {
    t3 = twMerge("flex max-h-full w-115 max-w-full flex-col", className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("dashboard.notifications.title");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <h4 className="min-w-0 truncate text-lg font-semibold">{t4}</h4>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !notifications;
  let t7;
  if ($[9] !== t) {
    t7 = t("dashboard.notifications.mark_all_read");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <span className="truncate">{t7}</span>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isMarkingAllAsRead || $[14] !== markAllNotificationsAsRead || $[15] !== t6 || $[16] !== t8) {
    t9 = <Button className="min-w-0" disabled={t6} isLoading={isMarkingAllAsRead} onClick={markAllNotificationsAsRead} size="sm" variant="link">{t8}</Button>;
    $[13] = isMarkingAllAsRead;
    $[14] = markAllNotificationsAsRead;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t5 || $[19] !== t9) {
    t10 = <div className="border-border-200 flex shrink-0 items-center justify-between gap-4 border-b p-4 pb-3">{t5}{t9}</div>;
    $[18] = t5;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== notifications) {
    t11 = notifications === undefined ? <NotificationsListSkeleton /> : notifications.items.length > 0 ? notifications.items.map(_temp) : <NotificationEmptyList />;
    $[21] = notifications;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <div className="flex min-h-0 flex-1 flex-col justify-start gap-1.5 overflow-y-auto px-1.5 py-3">{t11}</div>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <LinkWithoutPrefetch href="/profile/notification-settings" />;
    t14 = <Settings02Icon />;
    $[25] = t13;
    $[26] = t14;
  } else {
    t13 = $[25];
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t) {
    t15 = t("global.settings");
    $[27] = t;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15) {
    t16 = <span className="truncate">{t15}</span>;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== onNavigate || $[32] !== t16) {
    t17 = <Button onClick={onNavigate} variant="ghost-gray" size="sm" render={t13}>{t14}{t16}</Button>;
    $[31] = onNavigate;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <LinkWithoutPrefetch href="/notifications" />;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t) {
    t19 = t("dashboard.notifications.view_all");
    $[35] = t;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t19) {
    t20 = <span className="truncate">{t19}</span>;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <ChevronRightIcon />;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== onNavigate || $[41] !== t20) {
    t22 = <Button onClick={onNavigate} variant="primary" size="sm" render={t18}>{t20}{t21}</Button>;
    $[40] = onNavigate;
    $[41] = t20;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t17 || $[44] !== t22) {
    t23 = <div className="border-border-200 flex shrink-0 items-center justify-between gap-4 border-t pt-3 pr-4 pb-4 pl-2">{t17}{t22}</div>;
    $[43] = t17;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t10 || $[47] !== t12 || $[48] !== t23 || $[49] !== t3) {
    t24 = <div className={t3}>{t10}{t12}{t23}</div>;
    $[46] = t10;
    $[47] = t12;
    $[48] = t23;
    $[49] = t3;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  return t24;
};
function _temp(notification) {
  return <NotificationItem key={notification.id} notification={notification} />;
}